/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminImportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param query
     * @returns any Search TheSportsDB leagues by name
     * @throws ApiError
     */
    public importerControllerAdminSearchSportsDbLeagues(
        query?: string,
    ): CancelablePromise<Array<Record<string, any>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/import/thesportsdb/leagues/search',
            query: {
                'query': query,
            },
        });
    }
    /**
     * @param leagueId
     * @returns string List TheSportsDB seasons for a league
     * @throws ApiError
     */
    public importerControllerAdminListSportsDbSeasons(
        leagueId: number,
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/import/thesportsdb/leagues/{leagueId}/seasons',
            path: {
                'leagueId': leagueId,
            },
        });
    }
    /**
     * @param sport
     * @returns any List TheSportsDB leagues for admin import selection
     * @throws ApiError
     */
    public importerControllerAdminListSportsDbLeagues(
        sport?: string,
    ): CancelablePromise<Array<Record<string, any>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/import/thesportsdb/leagues',
            query: {
                'sport': sport,
            },
        });
    }
    /**
     * @param tournamentId
     * @param requestBody
     * @returns any Import TheSportsDB season schedule into local matches
     * @throws ApiError
     */
    public importerControllerAdminImportSportsDbMatches(
        tournamentId: number,
        requestBody: {
            season: string;
            updateExisting?: boolean;
        },
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/import/thesportsdb/tournaments/{tournamentId}/matches',
            path: {
                'tournamentId': tournamentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param tournamentId
     * @returns any Import TheSportsDB teams into a local tournament
     * @throws ApiError
     */
    public importerControllerAdminImportSportsDbTeams(
        tournamentId: number,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/import/thesportsdb/tournaments/{tournamentId}/teams',
            path: {
                'tournamentId': tournamentId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Create a local tournament from a TheSportsDB league and season
     * @throws ApiError
     */
    public importerControllerAdminImportSportsDbTournament(
        requestBody: {
            leagueId: number;
            season: string;
            name?: string;
            show?: boolean;
            dateStart?: string;
            dateEnd?: string;
        },
    ): CancelablePromise<{
        tournament?: Record<string, any>;
        league?: Record<string, any>;
        created?: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/import/thesportsdb/tournaments',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
